import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Adjunto} from "../../../../../chacra-core";

export {Adjunto} from "../../../../../chacra-core";


export const adjuntosAdapter: EntityAdapter<Adjunto> = createEntityAdapter<Adjunto>({
  selectId: model => `${model.adjuntoId}`,
  sortComparer: (a: Adjunto, b: Adjunto): number =>
    `${b.adjuntoId}`.localeCompare(`${a.adjuntoId}`)
});

export interface AdjuntosState extends EntityState<Adjunto> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: AdjuntosState = adjuntosAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
